var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "raphael:info",
    clipPath: "url(#clip0_1272_5384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99991 0.734375C3.98641 0.734375 0.73291 3.98787 0.73291 8.00138C0.73291 12.0149 3.98641 15.2684 7.99991 15.2684C12.0134 15.2684 15.2669 12.0149 15.2669 8.00138C15.2669 3.98787 12.0134 0.734375 7.99991 0.734375ZM7.37841 4.00137H8.58841V5.28838H7.37841V4.00137ZM9.38091 11.8124H8.04991C7.53291 11.8124 7.31241 11.5924 7.31241 11.0644V7.63138C7.31241 7.46638 7.22441 7.38988 7.07041 7.38988H6.63041V6.20138H7.96191C8.47941 6.20138 8.69891 6.43237 8.69891 6.94938V10.3929C8.69891 10.5479 8.78691 10.6349 8.94091 10.6349H9.38091V11.8124Z",
    fill: "#0059B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1272_5384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/Info-Icon.eb3eb5e44677c798f14b5783454c56f2.svg";
export { ForwardRef as ReactComponent };